//import logo from "../assets/logo2.svg"
import {NavLink} from "react-router-dom";

const Header = () => {

    return (
        <div className="w-full h-20 flex bg-white justify-between items-center border-b pl-10">
             <NavLink to={'/'} className={'hidden sm:block'}>
                <span> FMS</span>
            </NavLink>
            <NavLink to={'/'} className={'hidden sm:block'}>
               {/*  <img src={logo} className='h-full' alt={'GTBank Gh'}/> */}
            </NavLink>

           

           {/*  <div className={'flex items-center px-4 space-x-4'}>
                <a className="flex flex-col justify-center items-center rounded text-gt_primary"
                   href="https://www.hana.com/help-centre/in-branch-complaints" rel="noopener noreferrer"
                   target="_blank">
                    <img alt="lodge complaint" className="w-10 h-10" src="/images/compliant.png"/>
                    <span className="block text-xs mt-1.5"> Lodge Complaint </span>
                </a>

                <a className="flex flex-col justify-center items-center rounded mx-3 text-gt_primary"
                   href="https://www.ghana.com/login.aspx" rel="noopener noreferrer" target="_blank">
                    <img alt="internet-banking" className="w-10 h-10" src="/images/internet-banking.png"/>
                    <span className="block text-xs mt-1.5"> Internet Banking </span>
                </a>
            </div> */}

        </div>
    );
};

export default Header;